import { render, staticRenderFns } from "./DialogEdit.vue?vue&type=template&id=927247d6"
import script from "./DialogEdit.vue?vue&type=script&lang=js"
export * from "./DialogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports